import React, { Component } from "react";
import '../rnr.css';
import arch_diagram from '../architecture.png';

class About extends Component {
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">About</h4>
          <p className="lead">SCI-ASEAN Green Research Hackathon - Technical Challenge #2</p>
          <p>Proof of concept cloud-native web app that enables the design and pricing of innovative climate-based parametric insurance solutions.</p>
          <p className="lead">AWS Cloud Architecture Diagram</p>
          <img
                  alt="Cloud Architecture Diagram"
                  src={arch_diagram}
                  width="781"
                  height="553"

                />
        </div>
      </main>
    );
  }
}
 
export default About;